import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBusinessCrossroad = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "business-crossroad" }),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 11.189,
			y1: .75,
			x2: 11.189,
			y2: 2.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 11.189,
			y1: 8.25,
			x2: 11.189,
			y2: 11.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 11.189,
			y1: 17.25,
			x2: 11.189,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M20.189,8.25H3.689v-6h16.5l2.47,2.469a.75.75,0,0,1,0,1.061Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M3.689,11.25h16.5v6H3.689L1.22,14.78a.75.75,0,0,1,0-1.061Z"
		})
	]
});
export default SvgBusinessCrossroad;
